export enum CategoryStatus {
  Publish = 1,
  UnPublish = 2,
}
